/**
 * 参赛栏目的枚举转字符串
 * @param value 枚举
 */
export function gameItemEnumToString(value) {
  let text = ""
  switch (value) {
    case 'RES_CITY_SUS_URBAN_DEV':
      text = '韧性城市与城市可持续发展'
      break
    case 'ECO_SER_ASS_VALUE_REA_ECO_PRO':
      text = '生态系统服务评估与生态产品价值实现'
      break
    case 'ECO_PROTECT_RESTORE':
      text = '生态系统保护与修复'
      break
    case 'IND_ECO_DOU_CARBON_GOAL':
      text = '产业生态与双碳目标'
      break
    case 'ECO_REM_SENS_INTE_ECO_MANAGE':
      text = '生态遥感与智慧生态管理'
      break
  }
  return text
}

/**
 * 参赛栏目字符串转枚举
 * @param text
 */
export function gameItemStringToEnum(text) {
  let value = ""
  switch (text) {
    case '韧性城市与城市可持续发展':
      value = 'RES_CITY_SUS_URBAN_DEV'
      break
    case '生态系统服务评估与生态产品价值实现':
      value = 'ECO_SER_ASS_VALUE_REA_ECO_PRO'
      break
    case '生态系统保护与修复':
      value = 'ECO_PROTECT_RESTORE'
      break
    case '产业生态与双碳目标':
      value = 'IND_ECO_DOU_CARBON_GOAL'
      break
    case '生态遥感与智慧生态管理':
      value = 'ECO_REM_SENS_INTE_ECO_MANAGE'
      break
  }
  return value
}

/**
 * 得到参赛栏目的option
 */
export function getGameItemOption() {

  let options = [{
    value: 'RES_CITY_SUS_URBAN_DEV',
    label: '韧性城市与城市可持续发展'
  }, {
    value: 'ECO_SER_ASS_VALUE_REA_ECO_PRO',
    label: '生态系统服务评估与生态产品价值实现'
  }, {
    value: 'ECO_PROTECT_RESTORE',
    label: '生态系统保护与修复'
  }, {
    value: 'IND_ECO_DOU_CARBON_GOAL',
    label: '产业生态与双碳目标'
  }, {
    value: 'ECO_REM_SENS_INTE_ECO_MANAGE',
    label: '生态遥感与智慧生态管理'
  }]

  return options
}

/**
 * 审核状态枚举转字符串
 * @param value
 */
export function checkEnumToString(value) {
  let text = ""
  switch (value) {
    case 'NODATA':
      text = '未提交'
      break
    case 'CERTIFICATING':
      text = '审核中'
      break
    case 'APPROVED':
      text = '审核通过'
      break
    case 'REFUSED':
      text = '审核失败'
      break
  }
  return text
}

/**
 * 审核状态字符串转枚举
 * @param text
 */
export function checkStringToEnum(text) {
  let value = ""
  switch (text) {
    case '未提交':
      value = 'NODATA'
      break
    case '审核中':
      value = 'CERTIFICATING'
      break
    case '审核通过':
      value = 'APPROVED'
      break
    case '审核失败':
      value = 'REFUSED'
      break
  }
  return value
}

/**
 * 用户类型枚举转字符串
 * @param value
 */
export function userTypeEnumToString(value) {
  let text = ""
  switch (value) {
    case "MANAGER":
      text = '管理员'
      break
    case "REFEREE":
      text = '审稿人'
      break
    case "PLAYER":
      text = '参赛选手'
      break
    case "VISITOR":
      text = '游客'
      break
  }
  return text
}

/**
 * 用户类型字符串转枚举
 * @param text
 */
export function userTypeStringToEnum(text) {
  let value = ""
  switch (text) {
    case "管理员":
      value = 'MANAGER'
      break
    case "审稿人":
      value = 'REFEREE'
      break
    case "参赛选手":
      value = 'PLAYER'
      break
    case "游客":
      value = 'VISITOR'
      break
  }
  return value
}

/**
 * 新闻的枚举转字符串
 * @param value
 */
export function noticeEnumToString(value) {
  let text = ""
  switch (value) {
    case "NORMAL":
      text = '普通'
      break
    case "HOT":
      text = '热点'
      break
    case "URGENT":
      text = '置顶'
      break
  }
  return text
}

/**
 * 新闻字符串转枚举
 * @param text
 * @returns {string}
 */
export function noticeStringToEnum(text) {
  let value = ""
  switch (text) {
    case "普通":
      value = 'NORMAL'
      break
    case "热点":
      value = 'HOT'
      break
    case "加急":
      value = 'URGENT'
      break
  }
  return value
}

/**
 * 年级的枚举转字符串
 * @param text
 */
export function gradeEnumToString(value) {
  let text = ""
  switch (value) {
    case "UNDERGRADE":
      text = '本科生'
      break
    case "MASTER":
      text = '硕士研究生'
      break
    case "DOCTOR":
      text = '博士研究生'
      break
  }
  return text
}

/**
 * 年级的字符串转枚举
 * @param text
 */
export function gradeStringToEnum(text) {
  let value = ""
  switch (text) {
    case "本科生":
      value = 'UNDERGRADE'
      break
    case "硕士研究生":
      value = 'MASTER'
      break
    case "博士研究生":
      value = 'DOCTOR'
      break
  }
  return value
}



// WEBPACK FOOTER //
// ./src/util/EnumTransition.js